( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery", "./version" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
	"use strict";

// Create a local jQuery because jQuery Color relies on it and the
// global may not exist with AMD and a custom build (#10199).
// This module is a noop if used as a regular AMD module.
// eslint-disable-next-line no-unused-vars
var jQuery = $;

} );



//////////////////
// WEBPACK FOOTER
// /Users/alicorn/Sites/servier-multisite-countries/wp-content/themes/servier-multisite-countries/node_modules/jquery-ui/ui/jquery-var-for-color.js
// module id = 24
// module chunks = 0